import { combineReducers } from 'redux';
import { normalizeAPIError } from '../../errors';
import * as licenses from '../../settings/pricing-options';
import { daysSinceDate } from '../../utilities';

const statsByType = (
  state = {
    isFetching: false,
    message: null,
    types: {},
  },
  action
) => {
  const { type } = action;
  switch (type) {
    case 'FETCH_STATS_REQUEST':
      return {
        ...state,
        message: null,
        isFetching: true,
      };
    case 'FETCH_STATS_FAILURE':
      return {
        ...state,
        isFetching: false,
        message: normalizeAPIError(action.error, type),
      };
    case 'FETCH_STATS_SUCCESS': {
      return {
        ...state,
        isFetching: false,
        types: {
          ...state.items,
          [action.statsType]: action.response.results,
        },
      };
    }
    default:
      return state;
  }
};

const generic = (
  state = {
    isFetching: false,
    message: null,
    items: {},
  },
  action
) => {
  switch (action.type) {
    case 'FETCH_GENERIC_STATS_REQUEST':
      return {
        ...state,
        message: null,
        isFetching: true,
      };
    case 'FETCH_GENERIC_STATS_FAILURE':
      return {
        ...state,
        isFetching: false,
        message: normalizeAPIError(action.error, action.type),
      };
    case 'FETCH_GENERIC_STATS_SUCCESS':
      return {
        ...state,
        isFetching: false,
        items: {
          ...state.items,
          [action.route]: action.response,
        },
      };
    default:
      return state;
  }
};

const stats = combineReducers({
  statsByType,
  generic,
});
export default stats;

export const getSchoolStatsById = (state, id) => {
  const { schools } = state.statsByType.types;
  if (!schools) return null;
  return schools.find(school => school.school_id === parseInt(id, 10));
};
export const getSchoolStatsBreakdown = state => {
  const { schools } = state.statsByType.types;
  if (!schools) return null;
  const initialValue = {
    totalSchools: 0,
    activeTrials: 0,
    paidLicenses: 0,
    deactivedSchools: 0,
    allLicensesByType: {},
    activeLicensesByType: {},
    schoolsCreatedInLastDay: 0,
    schoolsCreatedInLastWeek: 0,
  };

  const schoolStats = schools.reduce((accumulator, school) => {
    const licenseTypeIncrementer = group => {
      if (!school.license_type) return false;
      if (Object.keys(accumulator[group]).includes(school.license_type)) {
        accumulator[group][school.license_type] += 1;
      } else {
        accumulator[group][school.license_type] = 0;
      }
      return false;
    };
    const plan = licenses.getPlanByLicense(school.license_type);

    accumulator.totalSchools += 1;
    licenseTypeIncrementer('allLicensesByType');
    if (school.school_deactivated) accumulator.deactivedSchools += 1;
    if (!school.school_deactivated && plan) {
      const creationDate = new Date(school.school_created);
      if (creationDate) {
        const days = daysSinceDate(creationDate);
        if (days < 1) accumulator.schoolsCreatedInLastDay += 1;
        if (days < 8) accumulator.schoolsCreatedInLastWeek += 1;
      }
      if (plan.availableUpgrade) accumulator.activeTrials += 1;
      if (!plan.availableUpgrade) accumulator.paidLicenses += 1;
      licenseTypeIncrementer('activeLicensesByType');
    }
    return accumulator;
  }, initialValue);
  return schoolStats;
};
export const getGenericStats = (state, endpoint) =>
  state.generic.items[endpoint];
export const isFetchingStats = (state, reducer) => {
  if (!Object.keys(state).includes(reducer)) return undefined;
  return state[reducer].isFetching;
};
